import React, { Component, Fragment } from 'react';
import * as HMS from "../../common/component/Index";
import Radio from '../../common/component/Radio';
import * as ANT from 'antd';
import * as Func from '../../../../helpers/functions';
import DEFINE, { ENUM_SOURCE_FLIGHT } from "../../../../constants/Define";
import  "./SourceFlight.less";

let permisionActions = [];
class SourceFlight extends Component {

    constructor(props) {
        super(props);
        this.state = {
            airlineSourceVJ: this.props.airlineSourceVJ,
            updateAirlineSource: this.props.updateAirlineSource,
        };
    }
    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.CONFIG_SOURCE_FLIGHT)
        this.props.getAirlineSourceVJ();
    }
    onChangeRadio = e => {
        this.setState({ airlineSourceVJ: e.target.value });
    };
    handleSubmit = () => {
        const { airlineSourceVJ } = this.state;
        const { updateAirlineSource } = this.props;
        if (airlineSourceVJ !== this.props.airlineSourceVJ) {
            updateAirlineSource({ airlineCode: "VJ", sourceCode: airlineSourceVJ });
        }
    };
    render() {
        const { t } = this.props;
        const  airlineSourceVJ  = this.state.airlineSourceVJ || this.props.airlineSourceVJ;
        const flightSources = [
            { value: ENUM_SOURCE_FLIGHT.VIET_JET, label: t('item.configSourceFlight.vieJet') },
            { value: ENUM_SOURCE_FLIGHT.DATA_COM, label: t('item.configSourceFlight.dataCom') },
        ];
    
        return (
            <Fragment>
                <HMS.HeaderListComponent
                    path={this.props.match.path}
                    groupPath={'config-source-flight'}
                />
                {permisionActions.allowView && (
                    <div className="container-source">
                        <div className="content-source">
                            <ANT.PageHeader
                                title={t('navigation.configSourceFlight')}
                                style={{ padding: 0, margin: 0 }}
                            >
                                <form onSubmit={e => e.preventDefault()}>
                                    <div><b>{t('item.configSourceFlight.ticketVieJet')}</b></div>
                                    <table>
                                    <tbody>
                                        {flightSources.map(({ value, label }) => (
                                            <tr key={value}>
                                                <td>
                                                    <Radio
                                                        disabled={!permisionActions.allowUpdate}
                                                        name="configSource"
                                                        value={value}
                                                        onChange={this.onChangeRadio}
                                                        checked={airlineSourceVJ === value}
                                                    />
                                                </td>
                                                <td>
                                                    <label>{label}</label>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan={2} style={{ textAlign: 'right' }}>
                                                <ANT.Button
                                                    type="primary"
                                                    onClick={this.handleSubmit}
                                                    disabled={!permisionActions.allowUpdate}
                                                >
                                                    {t('action.save')}
                                                </ANT.Button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </form>
                            </ANT.PageHeader>
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default SourceFlight;
